import { message } from "antd";
import { makeAutoObservable } from "mobx";
import Parse from "parse";
import { AddItemState } from "..";
import { Item, ItemAttributes } from "../../../parse";
import { $heinzerling } from "../../../service";
import { OrderState } from "../../orders";

export class CreateItemState {
  private _open: boolean = false;
  private orderstate: OrderState;

  constructor(orderstate: OrderState) {
    this.orderstate = orderstate;
    makeAutoObservable(this);
  }

  public get open(): boolean {
    return this._open;
  }

  public set open(v: boolean) {
    this._open = v;
  }

  public async save(
    data: Pick<ItemAttributes, "name" | "unit" | "description4">
  ) {
    try {
      data.unit ||= "?";

      const item = new Item({
        ...data,
        no: "APP-ITEM",
      });

      const savedobject = await $heinzerling.sync.saveObject(item);
      message.success("Artikel wurde gespeichert.");

      //Add item to order automatically
      const additemstate = new AddItemState(this.orderstate);
      await additemstate.fetchItems();
      additemstate.item = savedobject.id;
      additemstate.quantity = 1;

      if (!additemstate.item) {
        message.info(
          "Artikel gespeichert, konnte jedoch nicht automatisch hinzugefügt werden."
        );
        additemstate.cancel();
      } else {
        await additemstate.save();
      }
      this.open = false;
    } catch (error) {
      if (error instanceof Parse.Error) {
        message.error(
          "Speichern fehlgeschlagen: " + error.code + ": " + error.message
        );
      } else {
        message.error("Speichern fehlgeschlagen: Unbekannter Fehler");
      }
    }
  }
}
